import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, from } from 'rxjs';
import {StorageService} from "./storage.service";
import{Router} from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  public rolesList = ['Customer','Driver'];
  constructor(public storage :StorageService,
    public router : Router){

  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      const currentUser = this.storage.fetchUserStorageData();
      if(currentUser) {
          // check if route is restricted by role
          if (this.rolesList && this.rolesList.indexOf(currentUser.role) === -1) {
              // role not authorised so redirect to home page
              this.router.navigate(['/']);
              return false;
          } else {
            return true;
          }
      } else{
        this.router.navigate(['auth/login']);
        return false;
      }
    }
}
